<template>
  <a-card :bordered="false" class="m-t-10">
    <a-button size='small' @click="()=>{$router.go(-1)}">
      <LeftOutlined />返回
    </a-button>
    <span class="ml15 card_title">{{$route.query.type == 'add' ? '添加':'编辑'}}产品批次</span>
  </a-card>
  <a-card :bordered="false">
    <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item label="批次名称" name="batch_name" help='最多30个字符，只能输入英文字母或数字' >
        <a-input v-model:value="form.batch_name" placeholder='请输入批次名称' :maxlength='30' :suffix="form.batch_name.length+'/30'" />
      </a-form-item>
      <a-form-item label="关联商品" name="product_name">
        <a-input class="width85 m-r-15" v-model:value="goodsName" placeholder='请选择商品' readonly />
        <a-button type="primary" @click='showGood = true' :disabled="$route.query.type == 'edit'">选择</a-button>
      </a-form-item>
      <a-form-item label="生产日期" name="production_date">
        <a-date-picker  format="YYYY-MM-DD" valueFormat='YYYY-MM-DD' v-model:value="form.production_date"  />
      </a-form-item>
       <a-form-item label="保质期" >
         <a-radio-group v-model:value="form.validaity_mode"  >
            <a-radio :value="1" >
              有效天数
            </a-radio>
              <a-radio :value="2" >
            有效日期
            </a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="有效期" name="validaity_day" v-if="!form.validaity_mode||form.validaity_mode==1">
        <a-input-number style="width:334px;margin-right: 10px;" v-model:value="form.validaity_day" :min='0' :max='999' :precision='0' placeholder='请输入天数' />天
      </a-form-item>
     <a-form-item label="有效期" name="validity_date" v-if="form.validaity_mode==2">
         <a-date-picker v-model:value="form.validity_date"  :disabled="$route.query.type == 'edit'" />
      </a-form-item>
      <a-form-item label="备注" name="remark">
        <a-textarea v-model:value="form.remark" placeholder="可备注生产线、生产班组等信息" :rows="4" :maxlength='100' />
      </a-form-item>
        <a-form-item ref="inspection_report" label="检验报告" name="inspection_report" help="最多上传4张">
            <material :groupType="1" :imageList="form.inspection_report" :max="4" 
            v-on:handlechoose="(data) => {form.inspection_report.push(...data);}
              " v-on:handledel="(data) => {form.inspection_report = data;}" />
          </a-form-item>
      <a-form-item :wrapper-col="{ span: 10, offset: 2}">
        <a-button class="width-100 m-r-20" block @click="()=>{$router.go(-1)}">取消</a-button>
        <a-button class="width-100" block type="primary" @click="onSubmit">保存</a-button>
      </a-form-item>
    </a-form>
  </a-card>
  <a-modal  :keyboard="false" title="选择商品" v-model:visible="showGood" centered :width='1300' :footer="null" destroyOnClose>
    <selectGood v-on:select="goodSelect" :selectList='[{id:form.product_id}]' :checkout="false" :skuType='true'></selectGood>
  </a-modal>
</template>

<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { LeftOutlined } from "@ant-design/icons-vue";
  import { message } from "ant-design-vue";
  import { getProductBatchMore, addProductBatch, editProductBatch } from '@/api/product';
  import { iscode } from "@/utils/app";
  export default {
    components: { LeftOutlined },
    setup() {
      const ruleForm = ref();
      const form = ref({
        batch_name:'',
        production_date: '',
        validaity_day: '',
        remark:'',
        product_id:'',
        product_sn:'',
        product_name:'',
        product_sku_sn:'',
        product_sku_name:'',
        validaity_mode:1,//     1        有效期模式 1 天数 2日期
        validity_date:"",//有效日期
        inspection_report:[]
    });
      const state = reactive({
        labelCol: {span: 2},
        wrapperCol: {span: 10},
        showGood:false,
        goodsName:'',
        rules: {
          batch_name:[
            { required: true,  message: '请输入批次名称'},
            { pattern:new RegExp(/^[0-9a-zA-Z]*$/g),  message: '只能输入英文字母或数字'}
          ],
          product_name:[
            { required: true,  message: '请关联商品'}
          ],
          production_date:[
            { required: true,  message: '请选择生产日期'}
          ],
          validaity_day:[
            { required: true,  message: '请输入有效期'}
          ]
        },
      });
      const $route = inject("$route");
      const $Modal = inject("$Modal");
      const $router = inject("$router");
      //选择商品
      const goodSelect = (e) => {
        form.value.product_id = e.id
        form.value.product_sn = e.product_sn
        form.value.product_name = e.product_name
        form.value.product_sku_sn = e.product_sku_sn ? e.product_sku_sn : 0
        form.value.product_sku_name = e.product_sku_name
        state.goodsName = (e.product_sku_name?e.product_sku_name:'单规格')+' - '+e.product_name
        state.showGood = false
      }
      //获取详情
      const getMore = async () => {
        const hide = message.loading('正在加载中...', 0);
        let res = await getProductBatchMore({batch_id:$route.query.id}).then(res => res.data).catch(error => error);
        if (iscode(res)) {
          form.value = res.data
          if(!form.value.validaity_mode){
            form.value.validaity_mode=1
          }
          if(!form.value.inspection_report){
             form.value.inspection_report=[]
          }
          state.goodsName = (res.data.product_sku_name?res.data.product_sku_name:'单规格')+' - '+res.data.product_name
        } else {
          message.error(res.msg);
        }
        setTimeout(hide);
      }
      //提交
      const onSubmit = () => {
        ruleForm.value.validate().then(() => {
          $Modal.confirm({
            centered: true,
            title: '确认添加批次？',
            content: '保存后部分数据将无法进行修改',
            async onOk() {
              const hide = message.loading("正在加载中...", 0);
              let res
              if ($route.query.type == 'add') {
                res = await addProductBatch({ ...form.value}).then((res) => res.data).catch(error => error);
              } else {
                res = await editProductBatch({ ...form.value,batch_id:$route.query.id}).then((res) => res.data).catch(error => error);
              }
              if (iscode(res)) {
                message.success(res.msg);
                setTimeout(() => {
                  $router.go(-1);
                }, 2000);
              } else {
                message.error(res.msg);
              }
              setTimeout(hide);
            }
          })
        }).catch(error => {
          message.error('请完善表单！');
        });
      };
      onMounted(() => {
        if($route.query.type == 'edit'){
          getMore();
        }
      });
      return {
        form,
        ruleForm,
        ...toRefs(state),
        onSubmit,
        goodSelect,
      };
    },
  };
</script>